import { Config } from "@/utils/config.utils";

export const findGeocode = async (
    LocalitiesService: woosmap.map.LocalitiesService,
    latLng: woosmap.map.LatLngLiteral
) => {
    const geocodeResponse = await LocalitiesService.geocode({
        latLng: latLng,
        language: Config.getLocale()
    });

    const geocodeResult = geocodeResponse?.results.at(0);

    return geocodeResult;
};
